// extracted by mini-css-extract-plugin
export var wrapper = "Modal-module--wrapper--2CIb1";
export var open = "Modal-module--open--2CotO";
export var innerWrapper = "Modal-module--innerWrapper--3cSPE";
export var info = "Modal-module--info--UToGg";
export var small = "Modal-module--small--NcjU-";